import React from 'react';
import CalendarMonthOutlineIcon from './calendar-month-outline';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function CalendarIcon(props) {
  return ___EmotionJSX(CalendarMonthOutlineIcon, props);
}